import { motion } from "framer-motion";
import { Clock, Facebook, Instagram, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { EMAIL, FACEBOOK_URL, HOURS, INSTAGRAM_URL, MAPS_URL, PHONE_DISPLAY, WHATSAPP_NUMBER } from "../data/menu";
import { Leaf, Petal } from "./Decor";
import { LogoMark } from "./Logo";

const ACTIONS = [
  { icon: Phone, label: "Call Now", href: `tel:+91${PHONE_DISPLAY}`, testid: "contact-call-btn", primary: true },
  { icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/${WHATSAPP_NUMBER}`, testid: "contact-whatsapp-btn", primary: false },
  { icon: Instagram, label: "Instagram", href: INSTAGRAM_URL, testid: "contact-instagram-btn", primary: false },
  { icon: Facebook, label: "Facebook", href: FACEBOOK_URL, testid: "contact-facebook-btn", primary: false },
  { icon: MapPin, label: "Get Directions", href: MAPS_URL, testid: "contact-directions-btn", primary: false },
];

export const Contact = () => (
  <section id="contact" className="relative bg-[#FAF4EC] py-16 sm:py-24 overflow-hidden" data-testid="contact-section">
    <Petal className="absolute left-[8%] top-10 w-3.5 h-3.5" delay={0.8} />
    <Leaf className="absolute left-3 bottom-8 w-12 h-12 opacity-60" />
    <Leaf flip className="absolute right-3 top-10 w-12 h-12 opacity-60 hidden sm:block" />
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="bg-white rounded-[2rem] border border-[#EFE6DC] shadow-[0_24px_60px_-20px_rgba(61,35,20,0.18)] p-8 sm:p-12 text-center relative"
      >
        <div className="flex justify-center mb-4">
          <LogoMark size={56} />
        </div>
        <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#3A6B4C]">Get in Touch</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#3D2314] mt-2">
          Harshi&rsquo;s Kitchen
        </h2>
        <p className="font-hand text-xl text-[#D86A7A] mt-1">Homemade • Fresh • Delicious</p>

        <div className="mt-6 space-y-2.5 text-sm sm:text-base text-[#5A4232]">
          <p className="flex items-center justify-center gap-2">
            <Phone size={15} className="text-[#D86A7A]" />
            <a href={`tel:+91${PHONE_DISPLAY}`} className="hover:text-[#D86A7A] transition-colors font-medium">
              {PHONE_DISPLAY}
            </a>
          </p>
          <p className="flex items-center justify-center gap-2">
            <Mail size={15} className="text-[#D86A7A]" />
            <a href={`mailto:${EMAIL}`} className="hover:text-[#D86A7A] transition-colors break-all">
              {EMAIL}
            </a>
          </p>
          <p className="flex items-center justify-center gap-2">
            <Clock size={15} className="text-[#D86A7A]" /> {HOURS}
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mt-8">
          {ACTIONS.map((a) => (
            <a
              key={a.testid}
              data-testid={a.testid}
              href={a.href}
              target={a.href.startsWith("tel:") ? undefined : "_blank"}
              rel="noopener noreferrer"
              className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-all duration-300 hover:-translate-y-0.5 ${
                a.primary
                  ? "bg-[#D86A7A] hover:bg-[#C85265] text-white shadow-[0_10px_24px_-8px_rgba(216,106,122,0.55)]"
                  : "bg-[#FAF4EC] border border-[#E8D8C8] text-[#3D2314] hover:border-[#3A6B4C] hover:text-[#3A6B4C]"
              }`}
            >
              <a.icon size={16} /> {a.label}
            </a>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
